import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('rugby', true, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.000000, 24.000000) rotate(-45.000000) translate(-24.000000, -24.000000) translate(0.000000, 10.000000)",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: "24",
    cy: "14",
    rx: "24",
    ry: "14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,18 L24,10",
    transform: "translate(24.000000, 14.000000) rotate(180.000000) translate(-24.000000, -14.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,18 L30,10",
    transform: "translate(30.000000, 14.000000) rotate(180.000000) translate(-30.000000, -14.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,18 L18,10",
    transform: "translate(18.000000, 14.000000) rotate(180.000000) translate(-18.000000, -14.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,14.0083363 L40,14.0083363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,24 L8,4",
    transform: "translate(8.000000, 14.000000) rotate(180.000000) translate(-8.000000, -14.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,24 L40,4",
    transform: "translate(40.000000, 14.000000) rotate(180.000000) translate(-40.000000, -14.000000) "
  }))));
});